import httpClient from 'shared/lib/httpClient';
import { parseInsuranceList } from '../schemas/MasterDataSchema';

export const getInsuranceList = async (params) => {
  const response = await httpClient.get('/insurances', { params });
  return parseInsuranceList(response?.data);
};
